import * as React from 'react';

import styles from './signup-image.module.css';

export function SignupImage() {
    return (
        <div className={styles['container']}>
            <img src='/include/images/auth/signup-page-illustration.svg' alt='time-saving stats' />
        </div>
    );
}
